module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container edit-user-template company-edit"
  }, [_c('div', {
    staticClass: "container edit-user-template"
  }, [(_vm.dataLoading) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "loading-text"
  }, [_vm._v("loading ...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-header color-1-100"
  }, [_c('h1', [(_vm.canEditDetails) ? [_vm._v("\n          Edit organisation details:\n        ")] : _vm._e(), _vm._v(" "), (_vm.getUserRole === 'gm') ? [_vm._v("\n          " + _vm._s(this.company.details.name) + "\n        ")] : [_vm._v("\n          My company profile\n        ")]], 2), _vm._v(" "), (_vm.getUserRole === 'gm') ? [_c('div', {
    staticClass: "profile-actions float-none"
  }, [_c('button', {
    staticClass: "archive-profile",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.archiveProfile()
      }
    }
  }, [(_vm.company.details.enabled.value) ? [_vm._v("\n              Archive\n            ")] : [_vm._v("\n              Unarchive\n            ")]], 2), _vm._v(" "), _c('button', {
    staticClass: "delete-profile background-1-20 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteProfile()
      }
    }
  }, [_vm._v("Delete\n          ")]), _vm._v(" "), (_vm.company.details.isDemo) ? _c('button', {
    staticClass: "delete-profile background-1-20 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetTaskHistory()
      }
    }
  }, [_vm._v("\n            Reset task history\n          ")]) : _vm._e()])] : _vm._e()], 2), _vm._v(" "), (_vm.getUserRole !== 'gm') ? [_c('div', {
    staticClass: "admin-breadcrumbs"
  }, [_c('router-link', {
    staticClass: "dashboard background-1-20 color-2-100",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Go to Dashboard")])], 1)] : [_c('div', {
    staticClass: "admin-gm-breadcrumbs",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('button', {
    staticClass: "dashboard",
    class: [{
      'active': this.tabActive === 'profile'
    }],
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeTabActive('profile')
      }
    }
  }, [_vm._v("Profile\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "dashboard",
    class: [{
      'active': this.tabActive === 'billing'
    }],
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeTabActive('billing')
      }
    }
  }, [_vm._v("Billing")]), _vm._v(" "), (_vm.company.details.id) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'company-tasks',
        params: {
          companyId: _vm.company.details.id
        }
      }
    }
  }, [_vm._v("Tasks")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "progress",
    class: [{
      'active': this.tabActive === 'progress'
    }],
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeTabActive('progress')
      }
    }
  }, [_vm._v("Progress\n        ")]), _vm._v(" "), (_vm.company.details.industry && _vm.company.details.industry.landing) ? [_c('router-link', {
    staticClass: "landing",
    attrs: {
      "to": {
        name: 'company-landing',
        params: {
          id: _vm.company.details.industry.landing.slug
        }
      }
    }
  }, [_vm._v("\n            Landing\n          ")]), _vm._v(" "), (_vm.company.details.allowRegistration && _vm.company.details.allowRegistration.value && _vm.company.details.url) ? _c('router-link', {
    staticClass: "landing",
    attrs: {
      "to": {
        name: 'company-registration-landing',
        params: {
          industry: _vm.company.details.industry.landing.slug,
          company: _vm.company.details.url.toLowerCase()
        }
      }
    }
  }, [_vm._v("\n            Registration landing\n          ")]) : _vm._e()] : _vm._e()], 2)], _vm._v(" "), _c('div', {
    staticClass: "flex-block"
  }, [(this.tabActive === 'profile' || this.tabActive === 'progress') ? _c('div', {
    staticClass: "content-right-section anchors"
  }, [_c('div', {
    staticClass: "sticky-anchors background-1-40-before",
    attrs: {
      "tabindex": "-1"
    }
  }, [(this.tabActive === 'profile') ? [_c('div', {
    staticClass: "anchor-item color-1-20 details",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyDetails'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyDetails')
      }
    }
  }, [(_vm.canEditDetails === false) ? [_vm._v("Organisation details")] : [_vm._v("Edit organisation details")]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 owner",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyOwner'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyOwner')
      }
    }
  }, [(_vm.canEditOwner === false) ? [_vm._v("Account owner details")] : [_vm._v("Edit account owner details")]], 2)]), _vm._v(" "), (_vm.getUserRole === 'ca' || _vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "anchor-item color-1-20 details",
    class: [{
      'active  color-1-100': _vm.activeSection === 'tasksSettings'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('tasksSettings')
      }
    }
  }, [(_vm.canEditDetails === false) ? [_vm._v("Tasks settings")] : [_vm._v("Edit tasks settings")]], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 email-endings",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyRegistration'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyRegistration')
      }
    }
  }, [(_vm.canEditCompanyRegistration === false) ? [_vm._v("User registration settings")] : [_vm._v("Edit user registration settings")]], 2)])] : (this.tabActive === 'progress') ? [_c('div', {
    staticClass: "anchor-item color-1-20 progress",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyChart'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyChart')
      }
    }
  }, [_vm._v("Company chart")])]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 progress",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyProgress'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyProgress')
      }
    }
  }, [(_vm.canEditProgressChapters === false) ? [_vm._v("Company progress")] : [_vm._v("Edit company progress")]], 2)])] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-left-section"
  }, [(this.tabActive === 'profile') ? [_c('div', {
    ref: "companyDetails",
    staticClass: "content-section content-section__bordered border-1-20 profile-section no-margin-top",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditDetails === false) ? [_vm._v("Organisation details")] : [_vm._v("Edit organisation details")]], 2), _vm._v(" "), (_vm.canEditDetails === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditDetails()
      }
    }
  }, [_vm._v("Edit\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-name"
    }
  }, [_vm._v("Company name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.name),
      expression: "company.details.name"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Company name'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-company-name",
      "name": "Company name"
    },
    domProps: {
      "value": (_vm.company.details.name)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.details, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Company name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company name')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-parent"
    }
  }, [_vm._v("Parent company")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Company name'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "disabled": _vm.canEditDetails === false,
      "searchable": true,
      "options": _vm.preparedCompanies,
      "data-vv-name": "Parent company",
      "data-lpignore": "true",
      "name": "Company status",
      "id": "new-company-parent"
    },
    model: {
      value: (_vm.company.details.parent),
      callback: function($$v) {
        _vm.$set(_vm.company.details, "parent", $$v)
      },
      expression: "company.details.parent"
    }
  }), _vm._v(" "), (this.errors.has('Parent company')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Parent company')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-industry"
    }
  }, [_vm._v("Industry")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Industry'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "disabled": _vm.canEditDetails === false,
      "clearable": false,
      "searchable": false,
      "options": _vm.getIndustriesForSelect,
      "data-vv-name": "Industry",
      "data-lpignore": "true",
      "name": "Industry",
      "id": "new-company-industry"
    },
    model: {
      value: (_vm.company.details.industry),
      callback: function($$v) {
        _vm.$set(_vm.company.details, "industry", $$v)
      },
      expression: "company.details.industry"
    }
  }), _vm._v(" "), (this.errors.has('Industry')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Industry')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element form-element-date",
    attrs: {
      "id": "date-selector"
    }
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-subscription-end"
    }
  }, [_vm._v("Subscription ends on:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.subscriptionEnd),
      expression: "company.details.subscriptionEnd"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Subscription ends'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-company-subscription-end",
      "name": "Subscription ends"
    },
    domProps: {
      "value": (_vm.company.details.subscriptionEnd)
    },
    on: {
      "focus": function($event) {
        _vm.datepicker.shown = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.details, "subscriptionEnd", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canEditDetails && _vm.datepicker.shown),
      expression: "canEditDetails && datepicker.shown"
    }],
    staticClass: "datepicker"
  }, [_c('div', {
    staticClass: "datepicker-calendar-half"
  }, [_c('datepicker', {
    attrs: {
      "inline": true,
      "open-date": _vm.datepicker.subscription,
      "format": 'dd/MM/yyyy'
    },
    on: {
      "selected": function($event) {
        return _vm.dateSelected($event, 'subscriptionEnd')
      }
    },
    model: {
      value: (_vm.datepicker.subscription),
      callback: function($$v) {
        _vm.$set(_vm.datepicker, "subscription", $$v)
      },
      expression: "datepicker.subscription"
    }
  })], 1)]), _vm._v(" "), (this.errors.has('Subscription ends')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Subscription ends')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-status"
    }
  }, [_vm._v("Company status")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked is-blocked",
    class: [{
      'has-error': _vm.errors.has('Company status'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "disabled": true,
      "searchable": false,
      "options": _vm.getStatusesForSelect,
      "data-vv-name": "Company status",
      "data-lpignore": "true",
      "name": "Company status",
      "id": "new-company-status"
    },
    model: {
      value: (_vm.company.details.enabled),
      callback: function($$v) {
        _vm.$set(_vm.company.details, "enabled", $$v)
      },
      expression: "company.details.enabled"
    }
  }), _vm._v(" "), (this.errors.has('Company status')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company status')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [(_vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "companySizes"
    }
  }, [_vm._v("Company size")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': this.errors.has('Company size'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "disabled": _vm.canEditDetails === false,
      "clearable": false,
      "searchable": false,
      "options": _vm.companySizes,
      "data-vv-name": "Company size",
      "data-lpignore": "true",
      "name": "Company size",
      "id": "companySizes"
    },
    model: {
      value: (_vm.company.details.companySize),
      callback: function($$v) {
        _vm.$set(_vm.company.details, "companySize", $$v)
      },
      expression: "company.details.companySize"
    }
  }), _vm._v(" "), (this.errors.has('Company size')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company size')))]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [(_vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-types"
    }
  }, [_vm._v("User types")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': this.errors.has('User types'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "disabled": _vm.canEditDetails === false,
      "searchable": false,
      "clearable": false,
      "options": _vm.getDefaultRegistrationRolesForSelect,
      "data-vv-name": "User types",
      "data-lpignore": "true",
      "name": "User types",
      "id": "new-user-types"
    },
    model: {
      value: (_vm.company.details.usersType),
      callback: function($$v) {
        _vm.$set(_vm.company.details, "usersType", $$v)
      },
      expression: "company.details.usersType"
    }
  }), _vm._v(" "), (this.errors.has('User types')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('User types')))]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [(_vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "companyLocations"
    }
  }, [_vm._v("Company location")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Company location'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "disabled": _vm.canEditDetails === false,
      "searchable": false,
      "options": _vm.companyLocations,
      "data-vv-name": "Company location",
      "data-lpignore": "true",
      "name": "Company location",
      "id": "companyLocations"
    },
    model: {
      value: (_vm.company.details.companyLocation),
      callback: function($$v) {
        _vm.$set(_vm.company.details, "companyLocation", $$v)
      },
      expression: "company.details.companyLocation"
    }
  }), _vm._v(" "), (this.errors.has('Company location')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company location')))]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-id"
    }
  }, [_vm._v("Company id")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.id),
      expression: "company.details.id"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'is-blocked': _vm.canEditDetails,
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "data-lpignore": "true",
      "id": "new-company-id",
      "name": "Company id"
    },
    domProps: {
      "value": (_vm.company.details.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.details, "id", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.seesChat),
      expression: "company.details.seesChat"
    }],
    staticClass: "form-control form-control__checkbox",
    class: [{
      'has-error': _vm.errors.has('Sees the Chat box'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-company-chat",
      "name": "Sees the Chat box"
    },
    domProps: {
      "checked": Array.isArray(_vm.company.details.seesChat) ? _vm._i(_vm.company.details.seesChat, null) > -1 : (_vm.company.details.seesChat)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.company.details.seesChat,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.company.details, "seesChat", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.company.details, "seesChat", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.company.details, "seesChat", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-chat"
    }
  }, [_vm._v("Sees the Chat box")])]), _vm._v(" "), (_vm.company.details.disconnectedFromBilling) ? _c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.isDemo),
      expression: "company.details.isDemo"
    }],
    staticClass: "form-control form-control__checkbox",
    class: [{
      'has-error': _vm.errors.has('Demo company'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-company-demo",
      "name": "Demo company"
    },
    domProps: {
      "checked": Array.isArray(_vm.company.details.isDemo) ? _vm._i(_vm.company.details.isDemo, null) > -1 : (_vm.company.details.isDemo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.company.details.isDemo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.company.details, "isDemo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.company.details, "isDemo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.company.details, "isDemo", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-demo"
    }
  }, [_vm._v("Demo company")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.disconnectedFromBilling),
      expression: "company.details.disconnectedFromBilling"
    }],
    staticClass: "form-control form-control__checkbox",
    class: [{
      'has-error': _vm.errors.has('Disconnected from billing'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-company-disconnected-from-billing",
      "name": "Disconnected from billing"
    },
    domProps: {
      "checked": Array.isArray(_vm.company.details.disconnectedFromBilling) ? _vm._i(_vm.company.details.disconnectedFromBilling, null) > -1 : (_vm.company.details.disconnectedFromBilling)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.company.details.disconnectedFromBilling,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.company.details, "disconnectedFromBilling", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.company.details, "disconnectedFromBilling", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.company.details, "disconnectedFromBilling", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-disconnected-from-billing"
    }
  }, [_vm._v("Disconnected from billing")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditDetails) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditDetails()
      }
    }
  }, [_vm._v("Discard changes\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCompanyDetails()
      }
    }
  }, [_vm._v("Save changes\n              ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "companyOwner",
    staticClass: "content-section content-section__bordered border-1-20 profile-section",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditOwner === false) ? [_vm._v("Account owner details")] : [_vm._v("Edit account owner details")]], 2), _vm._v(" "), (_vm.canEditOwner === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditOwner()
      }
    }
  }, [_vm._v("Edit\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "owner-first-name"
    }
  }, [_vm._v("First name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.ownerData.firstName),
      expression: "company.ownerData.firstName"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('First name'),
      'is-locked': !_vm.canEditOwner
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditOwner === false,
      "data-lpignore": "true",
      "id": "owner-first-name",
      "name": "First name"
    },
    domProps: {
      "value": (_vm.company.ownerData.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.ownerData, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "owner-phone"
    }
  }, [_vm._v("Phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.ownerData.phoneNumber),
      expression: "company.ownerData.phoneNumber"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Phone number'),
      'is-locked': !_vm.canEditOwner
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditOwner === false,
      "data-lpignore": "true",
      "id": "owner-phone",
      "name": "Phone number"
    },
    domProps: {
      "value": (_vm.company.ownerData.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.ownerData, "phoneNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Phone number')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Phone number')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "owner-first-name"
    }
  }, [_vm._v("Last name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.ownerData.lastName),
      expression: "company.ownerData.lastName"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Last name'),
      'is-locked': !_vm.canEditOwner
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditOwner === false,
      "data-lpignore": "true",
      "id": "owner-last-name",
      "name": "Last name"
    },
    domProps: {
      "value": (_vm.company.ownerData.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.ownerData, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-email"
    }
  }, [_vm._v("Email address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.company.ownerData.email),
      expression: "company.ownerData.email"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Email'),
      'is-locked': !_vm.canEditOwner
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditOwner === false,
      "data-lpignore": "true",
      "id": "new-user-email",
      "name": "Email"
    },
    domProps: {
      "value": (_vm.company.ownerData.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.ownerData, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditOwner) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditOwner()
      }
    }
  }, [_vm._v("Discard changes\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCompanyOwner()
      }
    }
  }, [_vm._v("Save changes\n              ")])]) : _vm._e()]), _vm._v(" "), (_vm.getUserRole === 'ca' || _vm.getUserRole === 'gm') ? _c('div', {
    ref: "tasksSettings",
    staticClass: "content-section content-section__bordered border-1-20 profile-section",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditTasksSettings === false) ? [_vm._v("Tasks settings")] : [_vm._v("Edit tasks settings")]], 2), _vm._v(" "), (_vm.canEditTasksSettings === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openTasksSettings()
      }
    }
  }, [_vm._v("Edit\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-contraption"
    }
  }, [_vm._v("Company contraption")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.tasksSettings.contraption),
      expression: "company.tasksSettings.contraption"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Company contraption'),
      'is-locked': !_vm.canEditTasksSettings
    }],
    staticStyle: {
      "text-transform": "uppercase"
    },
    attrs: {
      "type": "text",
      "disabled": _vm.canEditTasksSettings === false,
      "data-lpignore": "true",
      "maxlength": "4",
      "id": "company-contraption",
      "name": "Company contraption"
    },
    domProps: {
      "value": (_vm.company.tasksSettings.contraption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.tasksSettings, "contraption", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "clearfix"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-default-assignee"
    }
  }, [_vm._v("Default assignee")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Default assignee'),
      'is-locked': !_vm.canEditTasksSettings
    }],
    attrs: {
      "disabled": _vm.canEditTasksSettings === false,
      "searchable": true,
      "options": _vm.defaultAssigneeForSelect,
      "data-vv-name": "Default assignee",
      "data-lpignore": "true",
      "name": "Default assignee",
      "id": "company-default-assignee"
    },
    model: {
      value: (_vm.company.tasksSettings.defaultAssignee),
      callback: function($$v) {
        _vm.$set(_vm.company.tasksSettings, "defaultAssignee", $$v)
      },
      expression: "company.tasksSettings.defaultAssignee"
    }
  }), _vm._v(" "), (this.errors.has('Default assignee')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Default assignee')))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-account-manager"
    }
  }, [_vm._v("Account manager")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Account manager'),
      'is-locked': !_vm.canEditTasksSettings
    }],
    attrs: {
      "disabled": _vm.canEditTasksSettings === false,
      "searchable": true,
      "options": _vm.adminUsersForSelect,
      "data-vv-name": "Account manager",
      "data-lpignore": "true",
      "name": "Account manager",
      "id": "company-account-manager"
    },
    model: {
      value: (_vm.company.tasksSettings.accountManager),
      callback: function($$v) {
        _vm.$set(_vm.company.tasksSettings, "accountManager", $$v)
      },
      expression: "company.tasksSettings.accountManager"
    }
  }), _vm._v(" "), (this.errors.has('Account manager')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Account manager')))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditTasksSettings) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditTasksSettings()
      }
    }
  }, [_vm._v("Discard changes\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCompanyTasksSettings()
      }
    }
  }, [_vm._v("Save changes\n              ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "companyRegistration",
    staticClass: "content-section content-section__bordered border-1-20 profile-section",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditCompanyRegistration === false) ? [_vm._v("User registration settings")] : [_vm._v("Edit user registration settings")]], 2), _vm._v(" "), (_vm.canEditCompanyRegistration === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditCompanyRegistration()
      }
    }
  }, [_vm._v("Edit\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-registration"
    }
  }, [_vm._v("Allow user registration")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Allow user registration'),
      'is-locked is-blocked': !_vm.canEditCompanyRegistration
    }],
    attrs: {
      "disabled": !_vm.canEditCompanyRegistration,
      "searchable": false,
      "options": _vm.yesNoOptionsForSelect,
      "data-vv-name": "Allow user registration",
      "data-lpignore": "true",
      "name": "Allow user registration",
      "id": "company-registration"
    },
    model: {
      value: (_vm.company.details.allowRegistration),
      callback: function($$v) {
        _vm.$set(_vm.company.details, "allowRegistration", $$v)
      },
      expression: "company.details.allowRegistration"
    }
  }), _vm._v(" "), (this.errors.has('Allow user registration')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Allow user registration')))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.company.details.allowRegistration && _vm.company.details.allowRegistration.value) ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-url"
    }
  }, [_vm._v("Company URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.url),
      expression: "company.details.url"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Company url'),
      'is-locked': !_vm.canEditCompanyRegistration
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditCompanyRegistration === false,
      "data-lpignore": "true",
      "id": "new-company-url",
      "name": "Company url"
    },
    domProps: {
      "value": (_vm.company.details.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.details, "url", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.company.details.allowRegistration && _vm.company.details.allowRegistration.value) ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-registration-all-emails"
    }
  }, [_vm._v("Only allow emails from an approved domain")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Allow all emails'),
      'is-locked is-blocked': !_vm.canEditCompanyRegistration
    }],
    attrs: {
      "disabled": !_vm.canEditCompanyRegistration,
      "searchable": false,
      "options": _vm.yesNoOptionsForSelect,
      "data-vv-name": "Allow all emails",
      "data-lpignore": "true",
      "name": "Allow all emails",
      "id": "company-registration-all-emails"
    },
    model: {
      value: (_vm.company.details.allowAllEmails),
      callback: function($$v) {
        _vm.$set(_vm.company.details, "allowAllEmails", $$v)
      },
      expression: "company.details.allowAllEmails"
    }
  }), _vm._v(" "), (this.errors.has('Allow all emails')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Allow all emails')))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.company.details.allowRegistration && _vm.company.details.allowRegistration.value) ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-registration-need-approval"
    }
  }, [_vm._v("New users must be approved by an admin")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Request approval'),
      'is-locked is-blocked': !_vm.canEditCompanyRegistration
    }],
    attrs: {
      "disabled": !_vm.canEditCompanyRegistration || (_vm.company.details.allowRegistration && !_vm.company.details.allowRegistration.value),
      "searchable": false,
      "options": _vm.yesNoOptionsForSelectNew,
      "data-vv-name": "Request approval",
      "data-lpignore": "true",
      "name": "Request approval",
      "id": "company-registration-need-approval"
    },
    model: {
      value: (_vm.company.details.emailApproval),
      callback: function($$v) {
        _vm.$set(_vm.company.details, "emailApproval", $$v)
      },
      expression: "company.details.emailApproval"
    }
  }), _vm._v(" "), (this.errors.has('Allow all emails')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Request approval')))]) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.company.details.allowRegistration && _vm.company.details.allowRegistration.value) ? _c('div', [_c('h3', {
    staticClass: "content-section-subtitle color-2-63"
  }, [_vm._v("Approved email domains")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.canEditCompanyRegistration === true) ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "pasteEmails"
    }
  }, [_vm._v("Bulk paste")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailControl['input']),
      expression: "emailControl['input']"
    }],
    staticClass: "form-control form-control__textarea",
    attrs: {
      "data-lpignore": "true",
      "rows": "2",
      "id": "pasteEmails",
      "cols": "20"
    },
    domProps: {
      "value": (_vm.emailControl['input'])
    },
    on: {
      "paste": function($event) {
        _vm.emailControl['isPaste'] = true
      },
      "blur": function($event) {
        return _vm.createTags($event, false, true)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.emailControl, 'input', $event.target.value)
      }, function($event) {
        return _vm.createTags($event, true)
      }]
    }
  })])]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.company.approvedEmails), function(row, index) {
    return _c('div', {
      staticClass: "form-group form-group-half",
      class: [{
        'form-group-right-item': (index > 0 && (index + 1) % 2 === 0) && _vm.canEditCompanyRegistration === true,
        'form-group__email-ending-input': _vm.canEditCompanyRegistration === true
      }]
    }, [_c('div', {
      staticClass: "form-element"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.email),
        expression: "row.email"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "title": "Email",
        "aria-label": "Email",
        "disabled": _vm.canEditCompanyRegistration === false,
        "data-lpignore": "true"
      },
      domProps: {
        "value": (row.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "email", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.canEditCompanyRegistration === true) ? _c('div', {
      staticClass: "form-group form-group-half form-group__email-ending-button form-group__email-ending-remove"
    }, [_c('div', {
      staticClass: "add-email-ending",
      on: {
        "click": function($event) {
          return _vm.removeElement(index)
        }
      }
    })]) : _vm._e()])
  }), _vm._v(" "), (_vm.canEditCompanyRegistration === true) ? _c('div', {
    staticClass: "form-group form-group-half form-group__email-add-button"
  }, [_c('div', {
    staticClass: "add-email-ending",
    on: {
      "click": _vm.addEmailRow
    }
  }, [_vm._v("Add new")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditCompanyRegistration) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditCompanyRegistration()
      }
    }
  }, [_vm._v("Discard changes\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCompanyRegistration()
      }
    }
  }, [_vm._v("Save changes\n              ")])]) : _vm._e()])] : (this.tabActive === 'billing') ? [_c('billing-profile', {
    attrs: {
      "embedded": true,
      "embedded-company-id": _vm.companyId
    }
  })] : (this.tabActive === 'progress') ? [_c('div', {
    ref: "companyChart",
    staticClass: "content-section profile-section no-margin-top",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'companyChart'
    }],
    style: ({
      display: !_vm.hasPoints ? 'none' : ''
    }),
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_c('h3', [_vm._v("Company progress")]), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "content-company-badge",
    attrs: {
      "id": "contentCompanyBadge"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.badgeCopy = true
      }
    }
  }, [_c('iframe', {
    attrs: {
      "width": "210",
      "height": "85",
      "src": _vm.getBadgeLink() + '?company=' + (_vm.company ? _vm.company.hash : '') + '&theme=' + (_vm.selectedHightCont === 1 ? 'dark' : 'light')
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content-chart-date"
  }, [_vm._v(_vm._s(_vm.getCurrentDate()))]), _vm._v(" "), _c('div', {
    staticClass: "content-chart-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-chart-body"
  }, [_c('div', {
    style: ({
      width: _vm.getChartWidth(_vm.chartData, true)
    })
  }, [_c('div', {
    staticClass: "content-chart-data",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, true)
    })
  }, [(!_vm.chartData) ? _c('div', {
    staticClass: "content-loading"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid"
  }, [_c('div', {
    staticClass: "content-chart-grid-line line_10"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_9",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_8",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_7",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_6",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_5",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_4",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_3",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_2",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-chart-grid-line line_1",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, false)
    })
  })]), _vm._v(" "), _vm._l((_vm.chartData), function(c, index) {
    return (c) ? _c('div', {
      staticClass: "content-chart-points"
    }, [_vm._l((c.scores), function(p) {
      return _c('div', {
        staticClass: "content-chart-point",
        class: 'chapter__' + c.chapter.id,
        style: ({
          left: p.left + 'px',
          top: p.top + '%',
          borderColor: c.chapter.color
        }),
        attrs: {
          "data-chapter": 'chapter-legend-' + c.chapter.id,
          "data-color": c.chapter.color
        }
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "content-chart-chapters__item",
      class: 'chapter_' + _vm.getChapterIndex(c),
      style: ({
        backgroundColor: c.hover && c.hover.type === 'level' && c.hover.show === true ? c.chapter.color : '',
        color: _vm.selectedHightCont === 1 ? (c.hover && c.hover.type === 'level' && c.hover.show === true ? '#000000' : c.chapter.color) : c.hover && c.hover.type === 'level' && c.hover.show === true ? '#000000' : '',
        borderColor: c.chapter.color
      }),
      attrs: {
        "id": 'chapter-legend-' + c.chapter.id
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.addChapterHover(c, 'level')
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.getChapterCustomName(c.chapter)) + "\n                      ")]), _vm._v(" "), (_vm.hasBenchmark(c)) ? _c('span', {
      staticClass: "show-benchmark tooltip",
      class: [{
        'active': c.hover && c.hover.type === 'benchmark' && c.hover.show === true
      }, 'chapter_' + _vm.getChapterIndex(c)],
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.addChapterHover(c, 'benchmark')
        }
      }
    }, [_c('span', {
      staticClass: "tooltip-text"
    }, [_vm._v("Show benchmark")])]) : _vm._e(), _vm._v(" "), (c.hover && c.hover.type === 'level' && c.hover.show === true) ? _c('div', {
      staticClass: "chapter-level",
      style: ({
        top: (100 - c.hover.top) + '%',
        height: c.hover.top + '%'
      })
    }) : _vm._e(), _vm._v(" "), (c.hover && c.hover.type === 'benchmark' && c.hover.show === true) ? _c('div', {
      staticClass: "chapter-benchmark",
      style: ({
        top: (100 - c.hover.top) + '%',
        height: c.hover.top + '%'
      })
    }) : _vm._e()], 2) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "content-chart-legend-x",
    style: ({
      width: _vm.getChartWidth(_vm.chartData, true)
    })
  }, _vm._l((_vm.quarters), function(quarter) {
    return _c('div', {
      staticClass: "content-chart-legend-x__item"
    }, [_vm._v("\n                      Q" + _vm._s(quarter.quarter) + " " + _vm._s(quarter.year) + "\n                    ")])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    ref: "companyProgress",
    staticClass: "content-section content-section__bordered border-1-20 profile-section",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditProgressChapters === false) ? [_vm._v("Company progress on task categories")] : [_vm._v("Edit company progress on task categories")]], 2), _vm._v(" "), (_vm.canEditProgressChapters === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openProgressChapters()
      }
    }
  }, [_vm._v("Edit\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group progress-table"
  }, [_c('table', {
    staticClass: "benchmark-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "has-order"
  }, [_c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeOrder()
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-change"
  }, [_c('div', {
    staticClass: "caption-head-order-up",
    class: {
      'active': this.chapterOrderBy !== null && this.chapterOrderBy.order
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-down",
    class: {
      'active': this.chapterOrderBy !== null && !this.chapterOrderBy.order
    }
  })])])]), _vm._v(" "), _c('th', [_vm._v("Policies and procedures")]), _vm._v(" "), _c('th', [_vm._v("Finding talent")]), _vm._v(" "), _c('th', [_vm._v("Assessing talent")]), _vm._v(" "), _c('th', [_vm._v("Retaining talent")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.editedChapters), function(row, index) {
    return _c('tr', [_c('td', {
      staticClass: "name"
    }, [_vm._v("Q" + _vm._s(row.quarter) + " " + _vm._s(row.year))]), _vm._v(" "), _c('td', [_c('div', {
      class: [{
        'is-disabled': _vm.canEditProgressChapters === false
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.score.policies),
        expression: "row.score.policies"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "title": "Policies and procedures score",
        "type": "number",
        "min": "0",
        "max": "100",
        "disabled": _vm.canEditProgressChapters === false,
        "data-lpignore": "true"
      },
      domProps: {
        "value": (row.score.policies)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row.score, "policies", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      class: [{
        'is-disabled': _vm.canEditProgressChapters === false
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.score.finding),
        expression: "row.score.finding"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "title": "Finding talent score",
        "type": "number",
        "min": "0",
        "max": "100",
        "disabled": _vm.canEditProgressChapters === false,
        "data-lpignore": "true"
      },
      domProps: {
        "value": (row.score.finding)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row.score, "finding", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      class: [{
        'is-disabled': _vm.canEditProgressChapters === false
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.score.assessing),
        expression: "row.score.assessing"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "title": "Assessing talent score",
        "type": "number",
        "min": "0",
        "max": "100",
        "disabled": _vm.canEditProgressChapters === false,
        "data-lpignore": "true"
      },
      domProps: {
        "value": (row.score.assessing)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row.score, "assessing", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      class: [{
        'is-disabled': _vm.canEditProgressChapters === false
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.score.retaining),
        expression: "row.score.retaining"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "title": "Retaining talent score",
        "type": "number",
        "min": "0",
        "max": "100",
        "disabled": _vm.canEditProgressChapters === false,
        "data-lpignore": "true"
      },
      domProps: {
        "value": (row.score.retaining)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row.score, "retaining", $event.target.value)
        }
      }
    })])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditProgressChapters) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditProgressChapters()
      }
    }
  }, [_vm._v("Discard changes\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateProgressChapters()
      }
    }
  }, [_vm._v("Save changes\n              ")])]) : _vm._e()])] : _vm._e()], 2)]), _vm._v(" "), (_vm.badgeCopy === true) ? _c('div', {
    staticClass: "badge-copy"
  }, [_c('div', {
    staticClass: "badge-copy-container"
  }, [_c('div', {
    staticClass: "badge-copy-close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.badgeCopy = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "badge-copy-selector"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "iframe-themes"
    }
  }, [_vm._v("Theme")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": true,
      "options": _vm.iframeThemes,
      "data-lpignore": "true",
      "id": "iframe-themes"
    },
    model: {
      value: (_vm.iframeTheme),
      callback: function($$v) {
        _vm.iframeTheme = $$v
      },
      expression: "iframeTheme"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "badge-copy-iframe",
    class: _vm.iframeTheme.value
  }, [_c('iframe', {
    attrs: {
      "width": "210",
      "height": "85",
      "id": "previewIframe",
      "src": _vm.getBadgeLink() + '?company=' + (_vm.company ? _vm.company.hash : '') + '&theme=' + _vm.iframeTheme.value
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "badge-copy-code"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.copyIframe()
      }
    }
  }, [_vm._v("Copy")]), _vm._v(" "), _c('textarea', {
    attrs: {
      "title": "Badge code",
      "id": "iframeCode",
      "rows": "3",
      "cols": "50",
      "onclick": "this.focus(); this.select()",
      "readonly": "readonly"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.getIframeCode())
    }
  })])])]) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-chart-legend-y"
  }, [_c('div', {
    staticClass: "content-chart-legend-y__item level-5"
  }, [_c('span', [_vm._v("Platinum")])]), _vm._v(" "), _c('div', {
    staticClass: "content-chart-legend-y__item level-4"
  }, [_c('span', [_vm._v("Gold")])]), _vm._v(" "), _c('div', {
    staticClass: "content-chart-legend-y__item level-3"
  }, [_c('span', [_vm._v("Silver")])]), _vm._v(" "), _c('div', {
    staticClass: "content-chart-legend-y__item level-2"
  }, [_c('span', [_vm._v("Bronze")])]), _vm._v(" "), _c('div', {
    staticClass: "content-chart-legend-y__item level-1"
  }, [_c('span', [_vm._v("Foundation")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Quarters")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8fe80b1a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/EditCompany.vue
// module id = 1042
// module chunks = 0